import React from 'react'
import Grid from '@mui/material/Grid'

import type { HolidayPackagesIndexEntry } from '@/src/types/holidays'

import PackageCardWrapper from '../packageCard'

interface PackagesResultsGridProps {
    packages: HolidayPackagesIndexEntry[]
    /** Reported as each card's `source_section`. */
    sourceSection: string
    isMobile: boolean
}

/**
 * The all-packages grid. Unlike `packageGrid`, every card carries its own collection — these cards
 * come from several collections at once, and the collection is what the detail URL is built from.
 */
const PackagesResultsGrid: React.FC<PackagesResultsGridProps> = ({ packages, sourceSection, isMobile }) => (
    // This theme redefines MUI's breakpoints — sm is 300px and md is 640px, not the default
    // 600/900, so `sm: 6` would put two narrow cards side by side on a phone.
    <Grid container spacing={isMobile ? 2 : 3}>
        {packages.map((entry, index) => (
            <Grid key={entry.slug} size={{ xs: 12, md: 6, lg: 4 }}>
                <PackageCardWrapper
                    summary={entry}
                    collectionSlug={entry.collectionSlug}
                    sourceSection={sourceSection}
                    cardPosition={index + 1}
                    isMobile={isMobile}
                />
            </Grid>
        ))}
    </Grid>
)

export { PackagesResultsGrid }
export type { PackagesResultsGridProps }
export default PackagesResultsGrid
